import React from 'react';
import '../../styles/DateRangeSelector.css';

/**
 * DateRangeSelector Component
 *
 * Allows users to select predefined or custom date ranges
 * Used in revenue optimization dashboard
 */
const DateRangeSelector = ({ period, onPeriodChange, startDate, endDate, onDateChange }) => {
  const periods = [
    { value: 'last30days', label: 'آخر 30 يوم', labelEn: 'Last 30 Days' },
    { value: 'thisMonth', label: 'هذا الشهر', labelEn: 'This Month' },
    { value: 'lastMonth', label: 'الشهر الماضي', labelEn: 'Last Month' },
    { value: 'thisYear', label: 'هذا العام', labelEn: 'This Year' },
    { value: 'custom', label: 'مخصص', labelEn: 'Custom' }
  ];

  return (
    <div className="date-range-selector" dir="rtl">
      <div className="period-buttons">
        {periods.map(p => (
          <button
            key={p.value}
            className={`period-btn ${period === p.value ? 'active' : ''}`}
            onClick={() => onPeriodChange(p.value)}
          >
            {p.label}
          </button>
        ))}
      </div>

      {period === 'custom' && (
        <div className="custom-date-inputs">
          <div className="date-input-group">
            <label>من</label>
            <input
              type="date"
              value={startDate}
              onChange={(e) => onDateChange('start', e.target.value)}
              max={endDate}
            />
          </div>
          <div className="date-input-group">
            <label>إلى</label>
            <input
              type="date"
              value={endDate}
              onChange={(e) => onDateChange('end', e.target.value)}
              min={startDate}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default DateRangeSelector;
